import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IPassage, ICreatePassageRequest } from "./types";

/**
 * 새로운 shared passage를 생성하는 API 함수
 */
export const apiCreatePassage = async (data: ICreatePassageRequest) => {
  const response = await apiPost<IPassage>("/passages", data);
  return response.data;
};

/**
 * 새로운 shared passage를 생성하는 React Query 훅
 */
export const useCreatePassage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreatePassage,
    onSuccess: (data) => {
      // 해당 exam paper의 passage 목록 갱신
      if (data) {
        queryClient.invalidateQueries({
          queryKey: ["passages", data.exam_paper_id],
        });
      }
    },
  });
};

export default useCreatePassage;
